import React from "react";

const EmptyCartNotice = ({ hasCartItems, navigate }) => {
  if (hasCartItems) return null;

  return (
    <div className="bg-amber-50 border border-amber-200 rounded-sm p-4 mb-6 text-center">
      <p className="text-amber-800 mb-2">Your cart is empty.</p>
      <button
        onClick={() => navigate("/shop")}
        className="bg-[#D4AF37] text-black px-4 py-2 rounded-sm text-sm font-medium hover:bg-[#C19B2E] transition-all duration-200"
      >
        Browse Products
      </button>
    </div>
  );
};

export default EmptyCartNotice;